module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/174a52d0c498c26afd00f8a16ed79549.png";